interface Config {
  isInitialState: () => boolean | 'ignore'
}

const config: Config = {
  isInitialState() {
    return false
  },
}

export function setConfig(conf: Partial<Config>) {
  Object.keys(conf).map(key => {
    config[key] = conf[key]
  })
}

// TODO[review]: Developer should not be able to modify config by getting it
export function getConfig() {
  return config
}
